import { IApiError } from '@/models/apiError.model';
import { IPromotion } from '@/models/promotion.model';

export const SLICE_NAME = 'coupons';

export interface CouponsState {
  coupons: IPromotion[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: CouponsState = {
  coupons: null,
  isLoading: false,
  error: null,
};
